import { Component, ViewChild, ViewContainerRef } from "@angular/core";
import { EventBroker } from "@ponder-core/events/eventBroker";
import { DisplayErrorEvent } from "@ponder-core/events/ui.events";
import { Subscription } from "rxjs";
import { ErrorPopUpComponent } from "./error-popup.component";

@Component({
    selector: "error-popup-container",
    imports: [],
    templateUrl: "./error-popup-container.component.html"
})
export class ErrorPopUpContainerComponent {
    @ViewChild("errorPopupTemplate", {read: ViewContainerRef}) errorPopupVcr!: ViewContainerRef;
    private errorDisplaySub!: Subscription;

    public constructor(private events: EventBroker) {
        this.errorDisplaySub = this.events.ui.displayErrorEvent.subscribe({
            next: (event: DisplayErrorEvent) => {
                this.onDisplayErrorEvent(event);
            }
        });
    }

    public ngOnDestroy(): void {
        this.errorDisplaySub.unsubscribe();
    }

    private onDisplayErrorEvent(event: DisplayErrorEvent): void {
        var errorPopupRef = this.errorPopupVcr.createComponent(ErrorPopUpComponent);

        errorPopupRef.instance.message = event.message;
        errorPopupRef.instance.durationSec = event.durationSec ?? errorPopupRef.instance.durationSec;
    }
}